import React, { useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { useSelector, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { Container, Grid } from "@material-ui/core";
import * as sourcesActions from "./actions";
import Table from "../../components/Table";
import BreadcrumbsHeader from "../../components/BreadcrumbsHeader";
import { makeStyles } from "@material-ui/core/styles";
import TableHeader from "../../components/TableHeader";
import paths from "../../constants/paths";

const useStyles = makeStyles((theme) => ({
  container: {
    overflowY: "hidden",
    flex: "1 1 auto",
  },
  tableWrapper: {
    overflowX: "hidden",
    overflowY: "auto",
  },
  contentArea: {
    marginTop: theme.spacing(4),
    maxHeight: "100%",
    flexWrap: "nowrap",
  },
  searchActionBar: {
    flex: "1 1 auto",
    display: "flex",
    justifyContent: "flex-end",
  },
}));

const Sources = () => {
  const dispatch = useDispatch();
  const { current: actions } = useRef(
    bindActionCreators({ ...sourcesActions }, dispatch)
  );
  const sources = useSelector(({ sourcesReducer }) => sourcesReducer);
  const login = useSelector(({ loginReducer }) => loginReducer);
  const classes = useStyles();

  useEffect(() => {
    if(login.isAdmin) actions.getSources()
    else dispatch(push(paths.alerts))
  }, []);

  const handleEdit = (id) => {
    dispatch(push(paths.getSourcesDetails(id)));
  };

  return (
    <Container className={classes.container}>
      <Grid container className={classes.contentArea} direction="column">
        <Grid container>
          <BreadcrumbsHeader crumbs={sources.crumbs} />
        </Grid>
        <TableHeader />
        <Grid item className={classes.tableWrapper}>
          <Table
            actions={{ handleEdit }}
            data={Object.values(sources.data)}
            dataIds={sources.dataIds}
            {...sources.table}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Sources;
